import React from "react";
import { Link } from "react-router-dom";
import {useNavigate} from "react-router-dom";

import "./Services.css";

function Services() {

  const navigate = useNavigate();
  return (
    <div className="services-section" id="services">
      <div className="serviceSectionHeader">
        <div id="heading">
          <h1>Our Services</h1>
        </div>
        <div id="s-button" onClick={() => navigate('/services')}>
          <button className="btn">
            <span>+</span>
            More Services
          </button>
        </div>
      </div>
      <div className="services-gallery">
        <div className="image">
          <img src="../../img/service1.jpg" alt="service" />
          <div className="image-desc">
            <h5>Consultations</h5>
            <p>
              We have a pool of trained medical personnel who offer different types of consultations as we focus on patient satisfaction.
              Our consultation package includes, patient education, diagnosis and treatments.
            </p>
            <Link to="/" className="read-more">Read More</Link>
          </div>
        </div>
        <div className="image">
          <img src="../../img/service3.jpg" alt="service" />

          <div className="image-desc">
            <h5>Cardiology</h5>
            <p>
             Our trained Cardiologists are always ready to perform proper examination on our patients and arrive at a
              long lasting solutions which have always been proved to be very to our patients.
            </p>
            <Link to="/" className="read-more">Read More</Link>
          </div>
        </div>
        <div className="image">
          <img src="../img/service6.jpg" alt="service" />
          <div className="image-desc">
            <h5>Dental Care</h5>
            <p>
             Having a problem identifying what might be the cause of your tooth decay? We have dental specialist
              trained to help you find the best way to manage your dental health.
            </p>
            <Link to="/" className="read-more">Read More</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
